export default __webpack_public_path__ + "static/media/deped-lg.1a5acaf0.png";